module.exports = __webpack_public_path__ + "static/media/adapters.81034b72.jpeg";